import {
  GetCompletedCateringEventDetailsQuery,
  GetCompletedDeliveryEventDetailsQuery,
  GetCompletedPopupEventDetailsQuery,
  GetUpcomingCateringEventDetailsQuery,
  GetUpcomingDeliveryEventDetailsQuery,
  GetUpcomingPopupEventDetailsQuery,
} from '@/api';

export type CateringEventVendorDetailsCompleted = Extract<
  NonNullable<NonNullable<GetCompletedCateringEventDetailsQuery['getEventVendors']>['eventVendors']>[number],
  { __typename: 'CateringEventVendor' }
>;
export type CateringEventVendorDetailsUpcoming = Extract<
  NonNullable<NonNullable<GetUpcomingCateringEventDetailsQuery['getEventVendors']>['eventVendors']>[number],
  { __typename: 'CateringEventVendor' }
>;

export type DeliveryEventVendorDetailsUpcoming = Extract<
  NonNullable<NonNullable<GetUpcomingDeliveryEventDetailsQuery['getEventVendors']>['eventVendors']>[number],
  { __typename: 'SelectEventVendor' }
>;
export type DeliveryEventVendorDetailsCompleted = Extract<
  NonNullable<NonNullable<GetCompletedDeliveryEventDetailsQuery['getEventVendors']>['eventVendors']>[number],
  { __typename: 'SelectEventVendor' }
>;
// NonNullable per field, not just Required<>: the schema types these as
// nullable Int, and the financial table cannot format a null.
export type DeliveryEventVendorFinancialDetails = {
  [K in
    | 'summaryOrderCount'
    | 'summaryItemCount'
    | 'summaryFoodSalesCents'
    | 'summaryTaxCents'
    | 'summaryTaxRemittedByFoodaCents'
    | 'summaryCommissionCents'
    | 'summaryPpFeesCents'
    | 'summaryPreliminaryEventTotalCents']-?: NonNullable<
    DeliveryEventVendorDetailsCompleted[K]
  >;
};

export type EventViewProps = React.PropsWithChildren<{
  eventStartTime: string;
  title?: string;
}>;

export type PopupEventVendorDetailsUpcoming = Extract<
  NonNullable<NonNullable<GetUpcomingPopupEventDetailsQuery['getEventVendors']>['eventVendors']>[number],
  { __typename?: 'PopupEventVendor' }
>;

export type MealFactor = NonNullable<
  NonNullable<PopupEventVendorDetailsUpcoming['mealPrep']>['factors']
>[number];

export type HistoricalItem = NonNullable<PopupEventVendorDetailsUpcoming['historical']>[number];

export type PopupEventVendorDetailsCompleted = Extract<
  NonNullable<NonNullable<GetCompletedPopupEventDetailsQuery['getEventVendors']>['eventVendors']>[number],
  { __typename?: 'PopupEventVendor' }
>;

export enum DeliveryEventStatus {
  CONFIRMED = 'Confirmed',
  UNCONFIRMED = 'Unconfirmed',
}

export type DeliveryManifest = DeliveryEventVendorDetailsUpcoming['preManifestDocument'];

export interface IEventDetails {
  placeName: string;
  locationAddress?: string;
  setupTime?: string;
  restaurant?: string;
  manifestTime?: string;
  readyAndBaggedTime?: string;
  endTime?: string;
  startTime?: string;
}

export interface IMenuItems {
  name: string;
  quantity: number;
  id: number | string;
}

export interface IEventDownloadDetails {
  sectionLabel: string;
  leftButtonLabel: string;
  leftDownloadUrl: string;
  leftIcon: string;
  rightIcon: string;
  rightButtonLabel: string;
  rightDownloadUrl: string;
  rightSectionIcon: boolean;
}

export type TBillingAddress = DeliveryEventVendorDetailsUpcoming['vendor']['address'];

export type UseTrackEvent = (
  event?:
    | PopupEventVendorDetailsUpcoming
    | PopupEventVendorDetailsCompleted
    | CateringEventVendorDetailsUpcoming
    | CateringEventVendorDetailsCompleted
    | DeliveryEventVendorDetailsUpcoming
    | DeliveryEventVendorDetailsCompleted
    | null
) => void;
